import { Speech } from 'lucide-react';
import type { ChatMessage as ChatMessageType } from '../../types';
import {
  AgentStatusShimmerRow,
  AGENT_STATUS_SHIMMER_DURATION,
  AGENT_STATUS_SHIMMER_SPREAD,
} from '@/components/chat/agent-status-shimmer-row';

interface VoiceStatusLineProps {
  message: ChatMessageType & { isDelta: true; deltaType: 'voice' };
  /** True while this is the latest voice line and the assistant turn is still streaming. */
  streaming?: boolean;
}

/**
 * Voice status row: static Speech icon; text shimmers L→R while this is the
 * active voice line for an in-progress turn, then settles to quiet muted text.
 */
export const VoiceStatusLine = ({ message, streaming = false }: VoiceStatusLineProps) => {
  if (!message.content.trim()) return null;

  return (
    <div
      className="agent-block-enter"
      role="status"
      aria-live="polite"
    >
      <AgentStatusShimmerRow
        icon={Speech}
        streaming={streaming}
        duration={AGENT_STATUS_SHIMMER_DURATION}
        spread={AGENT_STATUS_SHIMMER_SPREAD}
      >
        {message.content}
      </AgentStatusShimmerRow>
    </div>
  );
};
